// Angular dependencies
import { Injectable } from '@angular/core';

import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { tap, filter, switchMap } from 'rxjs/operators';

import { ApiService } from '../core/upgraded-providers';

import { AuthService } from '../auth.module';
import { FeaturesService } from '../features.service';

@Injectable()
export class SeasonsService {
    _destroySbj: Subject<void> = new Subject();

    _accessGrantedSbj: BehaviorSubject<any> = new BehaviorSubject(null);
    accessGranted$: Observable<any> = this._accessGrantedSbj.asObservable();

    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService,
        private _featuresSrv: FeaturesService
    ) {
        this._authSrv.user$
            .pipe(filter(() => !!this._featuresSrv.data['persistent-world']))
            .pipe(filter((user) => !!user))
            .pipe(tap(() => this.checkAccessGranted()))
            .subscribe();
    }

    async getAccessGranted(): Promise<any> {
        try {
            const response = await this._apiSrv.post('seasons/access/granted');

            this._accessGrantedSbj.next(true);

            return response;
        } catch (err) {
            throw new Error(err);
        }
    }

    async checkAccessGranted(): Promise<{ access: boolean }> {
        try {
            const { access } = await this._apiSrv.get('seasons/access/granted');

            this._accessGrantedSbj.next(access);

            return { access };
        } catch (err) {
            throw new Error(err);
        }
    }
}
